import React, { Component } from 'react';
import './Description.css';

export default class Description extends Component {
  constructor(props) {
    super(props);
    this.state = {
      input: ''
    };

    this.editStyleDisplay = this.editStyleDisplay.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  editStyleDisplay = () => {
    let display = this.props.edit ? 'flex' : 'none';
    return { display };
  };

  onChange(e) {
    const value = e.target.value;
    this.setState({ input: value });
  }

  handleClick(e) {
    e.preventDefault();
    let input = this.state.input;
    this.props.onClick(this.props.id, 'description', input);
    document
      .getElementById('food-page-description-form' + this.props.id)
      .reset();
  }

  render() {
    return (
      <div className="description">
        <p>{this.props.description}</p>

        <form
          onSubmit={this.handleClick}
          style={this.editStyleDisplay()}
          id={'food-page-description-form' + this.props.id}
        >
          <textarea
            rows="3"
            placeholder="Beschreibung hinzufügen.."
            onChange={this.onChange}
          />
          <div className="btn" onClick={this.handleClick}>
            +
          </div>
        </form>
      </div>
    );
  }
}
